import { connect } from "react-redux";
import { Component } from "react";
import { withRouter } from "react-router-dom";

export const mapStateToVersionIncompatible = function (state) {
  return {
    versionIncompatible:
      state &&
      state.networkStateReducer &&
      state.networkStateReducer.versionIncompatible
  };
};

export class VersionIncompatible extends Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.versionIncompatible &&
      prevProps.location.pathname !== this.props.location.pathname &&
      this.props.checkVersion
    ) {
      window.location.reload();
    }
  }

  render() {
    return null;
  }
}

export default withRouter(
  connect(mapStateToVersionIncompatible)(VersionIncompatible)
);
